import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	title: {
		margin: '0 auto',
		maxWidth: 550,
	},
});
